import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import {
  BRAND_FULL_NAME,
  BRAND_NAME,
  BRAND_TAGLINE,
  logoImage,
} from '../../config/brand';

const Footer: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const scrollToSection = (sectionId: string) => {
    if (location.pathname === '/') {
      document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
      return;
    }
    navigate('/');
    window.setTimeout(() => {
      document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
    }, 120);
  };

  return (
    <footer className="border-t border-[#E5DCCF] bg-[#F5F1E8] text-[#001848]" dir="rtl">
      <div className="h-1 w-full bg-gradient-to-l from-[#CC9C54] via-[#C09048] to-[#A87824]" />

      <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6 sm:py-12 lg:px-8">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:gap-10">
          <div>
            <Link to="/" className="mb-4 inline-flex items-center gap-3">
              <img
                src={logoImage}
                alt={BRAND_NAME}
                className="h-12 w-auto max-w-[7.5rem] object-contain sm:h-14 sm:max-w-[8.5rem]"
              />
            </Link>
            <h3 className="mb-2 text-lg font-bold font-cairo-bold sm:text-xl">{BRAND_FULL_NAME}</h3>
            <p className="mb-1 text-sm text-[#A87824]">{BRAND_TAGLINE}</p>
            <p className="max-w-xs text-sm leading-relaxed text-[#5A6B82]">
              كورسات أونلاين لجميع المراحل الدراسية مع نخبة من المدرسين.
            </p>
          </div>

          <div>
            <h4 className="mb-4 text-sm font-bold text-[#A87824]">روابط سريعة</h4>
            <nav className="flex flex-col gap-1" aria-label="روابط التذييل">
              <Link
                to="/"
                className="inline-flex min-h-11 items-center rounded-lg px-2 text-sm text-[#5A6B82] transition-colors hover:bg-[#EFE8DC] hover:text-[#001848]"
              >
                الرئيسية
              </Link>
              <button
                type="button"
                onClick={() => scrollToSection('teachers-section')}
                className="inline-flex min-h-11 items-center rounded-lg px-2 text-sm text-[#5A6B82] transition-colors hover:bg-[#EFE8DC] hover:text-[#001848]"
              >
                المدرسون
              </button>
              <button
                type="button"
                onClick={() => scrollToSection('why-choose-section')}
                className="inline-flex min-h-11 items-center rounded-lg px-2 text-sm text-[#5A6B82] transition-colors hover:bg-[#EFE8DC] hover:text-[#001848]"
              >
                لماذا نحن
              </button>
              <Link
                to="/login"
                className="inline-flex min-h-11 items-center rounded-lg px-2 text-sm text-[#5A6B82] transition-colors hover:bg-[#EFE8DC] hover:text-[#001848]"
              >
                تسجيل الدخول
              </Link>
              <Link
                to="/register"
                className="inline-flex min-h-11 items-center rounded-lg px-2 text-sm text-[#5A6B82] transition-colors hover:bg-[#EFE8DC] hover:text-[#001848]"
              >
                إنشاء حساب
              </Link>
            </nav>
            <div className="mt-5 flex flex-wrap gap-3 text-xs text-[#5A6B82]">
              <Link to="/privacy-policy" className="hover:text-[#A87824]">
                سياسة الخصوصية
              </Link>
              <span aria-hidden>·</span>
              <Link to="/terms-of-service" className="hover:text-[#A87824]">
                شروط الاستخدام
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-[#E5DCCF] pt-6 text-center sm:flex-row sm:text-start">
          <p className="text-xs text-[#5A6B82] sm:text-sm">
            © {new Date().getFullYear()} {BRAND_NAME}. جميع الحقوق محفوظة.
          </p>
          <p className="text-xs text-[#5A6B82]">
            تطوير <span className="font-semibold text-[#A87824]">EduCraft</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
